import { set, observable, action } from 'mobx';
import { IVariableResponse, TVariableType } from '../types/server.types';
import { TRootStore } from '~/types/app.types';

export type VariableDataForServer = Pick<
    IVariableResponse,
    'variable_id' | 'value'
>;

export class Variable<Value = any> {
    rootStore: TRootStore;

    @observable connected_block_id: string;
    @observable data_source_property?: string;
    @observable data_source_type?: string;
    @observable diverged_on: string;
    @observable invalidated_on: string;
    @observable raw_value: Value;
    @observable value: Value;
    @observable variable_id: string;
    @observable is_manual_value: string;
    type: TVariableType;

    constructor(variable: IVariableResponse, rootStore: TRootStore) {
        this.rootStore = rootStore;
        if (!variable) {
            return;
        }

        set(this, variable);
    }

    @action
    setValue(value) {
        this.value = value;
    }

    getDataForServer(): VariableDataForServer {
        const { variable_id, value } = this;

        return {
            variable_id,
            value
        };
    }
}
